import {Stepper} from 'apps/Checkout/Left/Stepper/Stepper'
import {TrustBlock} from 'components/common/TrustBlock/TrustBlock'
import {Button} from 'components/system/Button'
import {usePreviousStepperPath} from 'hooks/usePreviousStepperPath'
import {ReactComponent as LeftIcon} from 'icons/left.svg'
import {useActivityPath, useMoreToursPath, usePaymentPath, useTravelerPath} from 'providers/EnvironmentProvider'
import {useOrderDetailsMutators} from 'providers/OrderDetailsProvider'
import {useCallback, useEffect} from 'react'
import {Route, Routes} from 'react-router'
import {BrowserRouter} from 'react-router-dom'
import {Activity} from './pages/Activity/Activity'
import {Contact} from './pages/Contact/Contact'
import {MoreTours} from './pages/MoreTours/MoreTours'
import {Payment} from './pages/Payment/Payment'

export const Left = () => {
  const currentPath = window.location.pathname

  const travelerPath = useTravelerPath()
  const activityDetailsPath = useActivityPath()
  const moreToursPath = useMoreToursPath()
  const paymentPath = usePaymentPath()
  const {pushLocation} = useOrderDetailsMutators()

  useEffect(() => {
    pushLocation(window.location.href)
  }, [pushLocation])

  const previousStepperPath = usePreviousStepperPath(currentPath)

  const back = useCallback(() => {
    window.location.href = previousStepperPath
  }, [previousStepperPath])

  return (
    <div className="w-full d:w-[566px]">
      {currentPath !== travelerPath && (
        <Button
          className="hidden d:flex items-center gap-1 text-gray-1 border border-solid border-gray-1 rounded-lg py-2 px-3"
          onClick={back}
        >
          <LeftIcon />
          Back
        </Button>
      )}
      <Stepper />
      <BrowserRouter>
        <Routes>
          <Route path={travelerPath} element={<Contact />} />
          <Route path={activityDetailsPath} element={<Activity />} />
          <Route path={moreToursPath} element={<MoreTours />} />
          <Route path={paymentPath} element={<Payment />} />
          <Route path="*" element={<Contact />} />
        </Routes>
      </BrowserRouter>
      <div className="block d:hidden pt-4">
        <TrustBlock />
      </div>
    </div>
  )
}
